module.exports = __webpack_public_path__ + "img/vrc.de74f516.svg";